import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const DailySVG = styled.svg`
	width: 14px;
	height: 20px;

	.daily,
	.daily-1,
	.daily-2,
	.daily-3 {
		fill: #a2a9ad;
	}
`;

export const DailySelector = props => {
	const { id, theme, module, position, className } = props;
	const rotate = position === 'left' ? 'rotate(90)' : 'rotate(270)';
	return (
		<DailySVG id={id} module={module} width='8.582' height='8.582' viewBox='0 0 8.582 8.582'>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform={rotate}
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<path
				id='Daily-Calendar'
				d='M205.725 209.723h7.92a.332.332 0 0 1 .331.331v7.922a.33.33 0 0 1-.331.329h-7.92a.33.33 0 0 1-.331-.329v-7.922a.332.332 0 0 1 .331-.331zm4.015 6.267a1.176 1.176 0 0 0 .4.763 1.28 1.28 0 0 0 .861.283 1.214 1.214 0 0 0 1.034-.5 1.382 1.382 0 0 0 .273-.842 1.281 1.281 0 0 0-.338-.916 1.1 1.1 0 0 0-.825-.355 1.111 1.111 0 0 0-.5.122l.115-.648h1.382v-.684H210.2l-.374 1.984.592.086a.754.754 0 0 1 .566-.278.528.528 0 0 1 .408.175.755.755 0 0 1 .161.528.851.851 0 0 1-.161.561.5.5 0 0 1-.389.185.5.5 0 0 1-.353-.144.621.621 0 0 1-.185-.391l-.729.074zm-1.1.981v-3.83h-.6a1.327 1.327 0 0 1-.458.612 2.1 2.1 0 0 1-.621.355v.664a2.5 2.5 0 0 0 .945-.556v2.756zm-2.583-5.056h7.26v-1.53h-.65v.492a.33.33 0 0 1-.66 0v-.492H210.9v.492a.329.329 0 1 1-.657 0v-.492h-1.108v.492a.331.331 0 0 1-.662 0v-.492h-1.106v.492a.331.331 0 0 1-.662 0v-.492h-.648v1.53zm7.26.4h-7.26v5.334h7.26v-5.334z'
				class={className}
				transform='translate(-205.394 -209.723)'
			/>
		</DailySVG>
	);
};
